import React from 'react';

type ButtonProps = {
  visible: boolean;
  disabled?: boolean;
  text: string;
  onClick: () => void;
};

const SecondaryButton = ({ visible, disabled, text, onClick }: ButtonProps) => {
  return (
    <>
      {visible && (
        <button className="btn thule-btn-secondary w-100" onClick={onClick} disabled={disabled}>
          {text}
        </button>
      )}
    </>
  );
};

export default SecondaryButton;
